export default {
  main: '#167000',
  secondary: '#FF0D00',
  contrastingColor: '#ffffff',
  priceColor: '#FF0D00',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
